module.exports = __webpack_public_path__ + "bo.svg?607a7e950232d775102e79abc0076c93";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bo.svg
// module id = 1011
// module chunks = 27